import { CompactType, DisplayGrid, GridsterConfig, GridType } from 'angular-gridster2';

export const ReportDashboardGridsterBaseConfig: GridsterConfig = {
  gridType: GridType.VerticalFixed,
  // displayGrid: DisplayGrid.Always,
  displayGrid: DisplayGrid.OnDragAndResize,
  pushItems: true,
  pushResizeItems: false,
  pushDirections: { north: false, east: false, south: true, west: false },
  swap: true,
  disableScrollHorizontal: true,
  compactType: CompactType.CompactUp,
  scrollToNewItems: false,
  fixedRowHeight: 172,
  outerMarginTop: 10,
  outerMarginRight: 20,
  outerMarginLeft: 20,
  margin: 12,
  minCols: 12,
  maxCols: 12,
  maxItemCols: 12,
};
